import { Button } from 'react-bootstrap';
import React from 'react';
import financialAnalysisFeature from '../../assets/images/financial-analysis-feature.png';
import { NumberedListIndex } from '../../commons/components/NumberedListIndex';
import { openUrlInNewTab } from '../../util/window-utils';
import { businessPlanConfig } from '../../commons/config';
import useAnalytics from '../../web-analytics/webAnalyticsContext';
import { AnalyticsEvent } from '../../web-analytics/AnalyticsEvent';
import useAnalyticsPage from '../../web-analytics/hooks/useAnalyticsPage';
import { Page } from '../../web-analytics/Page';
import { DownloadBusinessPlanFinancialTemplateButton } from './DownloadBusinessPlanFinancialTemplateButton';

export const FinancialAnalysis = () => {
  useAnalyticsPage(Page.BUSINESS_PLAN_FINANCIAL_ANALYSIS);
  const analytics = useAnalytics();

  return (
    <div className="survey-info__container">
      <div className="survey-info__block">
        <div>
          A comprehensive financial analysis is a vital component of your business plan, showcasing
          your company’s financial health and projections. This section helps potential investors,
          lenders, or stakeholders understand your business's viability and financial strategy. To
          complete the Financial Analysis section, you have two options:
        </div>
        <img src={financialAnalysisFeature} alt="Financial analysis" />
      </div>
      <div className="survey-info__block">
        <div>
          <div className="survey-info__block-header">
            <span>
              <div className="d-inline-block">
                <NumberedListIndex num={1} />
              </div>{' '}
              DIY with a Spreadsheet Template
            </span>
          </div>
          <div>
            Download our free pre-built spreadsheet template. Enter your financial figures, and the
            template will calculate key metrics automatically. Use the results to manually complete
            the financial section of your business plan.
          </div>
        </div>
        <div>
          <DownloadBusinessPlanFinancialTemplateButton />
        </div>
      </div>
      <span className="survey-info__text-between-blocks">or</span>
      <div className="survey-info__block">
        <div>
          <div className="survey-info__block-header">
            <span>
              <div className="d-inline-block">
                <NumberedListIndex num={2} />
              </div>{' '}
              Professional Assistance
            </span>
          </div>
          <div>
            Schedule a consultation with the Growegy team. Our experts will guide you through the
            process and craft a tailored financial analysis for your business plan.
          </div>
        </div>
        <div>
          <div className="billing__schedule-consultation-container">
            <Button
              type="button"
              className="button-apply survey-section__save-button"
              disabled={false}
              onClick={() =>
                openUrlInNewTab(businessPlanConfig.consultationUrl, {
                  analytics,
                  analyticsEvent: AnalyticsEvent.CONSULTATION_SCHEDULER_OPENED,
                  properties: { source: 'business-plan-financial-analysis' },
                })
              }
            >
              Schedule a consultation
            </Button>
            <div className="growegy-font12 text-center">$30 for 30 minutes (Net30)</div>
          </div>
        </div>
      </div>
    </div>
  );
};
